import S3ImageUploader from "@common-components/s3-image-uploader";
import { SIGNED_URL_UPLOAD_TYPE, useError, useLoader, useNotification, useUpdateSpace, } from "@piiqtechnologies/ui-lib";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const SpaceCoverPhoto = ({ coverPhoto, spaceId }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setNotification } = useNotification();
    const [updateSpace, spaceUpdated, isUpdatingSpace, updateSpaceError] = useUpdateSpace();
    useEffect(() => {
        setLoader(isUpdatingSpace);
        return () => setLoader(false);
    }, [isUpdatingSpace]);
    useEffect(() => {
        if (updateSpaceError) {
            setError(updateSpaceError === null || updateSpaceError === void 0 ? void 0 : updateSpaceError.message);
        }
    }, [updateSpaceError]);
    useEffect(() => {
        if (spaceUpdated) {
            setNotification(intl.formatMessage(messages.updateSpaceCoverPhotoSuccess));
        }
    }, [spaceUpdated]);
    const onCoverPhotoChange = (imageUrl) => {
        const spaceAtts = {
            _id: spaceId,
            coverPhoto: {
                name: (coverPhoto === null || coverPhoto === void 0 ? void 0 : coverPhoto.name) || "",
                url: imageUrl || "",
                urlChangedAt: new Date().toISOString(),
            },
        };
        updateSpace(spaceAtts);
    };
    return (React.createElement(S3ImageUploader, { imageKey: spaceId, imageUrl: coverPhoto === null || coverPhoto === void 0 ? void 0 : coverPhoto.url, label: intl.formatMessage(messages.spaceCoverPhotoUploadTitle), onChange: onCoverPhotoChange, bucket: SIGNED_URL_UPLOAD_TYPE.SPACE_COVERPHOTO }));
};
export default SpaceCoverPhoto;
